module.exports = __webpack_public_path__ + "static/media/editform.e64256fc.svg";